import * as React from "react";
import { SVGProps } from "react";
import "./svgs.scss";

const Merchant = (props: SVGProps<any>): JSX.Element  => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 22}
    height={props.height || 22}
    fill="none"
    viewBox='0 0 20 20'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      stroke="#A0A4A8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.75 10.905v5.345a.625.625 0 0 0 .625.625h11.25a.625.625 0 0 0 .625-.625v-5.345M4.221 3.125H15.78a.625.625 0 0 1 .6.453L17.5 7.5h-15l1.12-3.922a.625.625 0 0 1 .601-.453Z"
    />
    <path
      stroke="#A0A4A8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.5 7.5v1.25a2.5 2.5 0 0 1-5 0V7.5"
    />
    <path
      stroke="#A0A4A8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.5 7.5v1.25a2.5 2.5 0 0 1-5 0V7.5"
    />
    <path
      stroke="#A0A4A8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.5 7.5v1.25a2.5 2.5 0 0 1-5 0V7.5"
    />
  </svg>
);

export default Merchant;
